<script setup lang="ts">
import { cn } from '../ui-utils.ts';
import { SelectIcon, SelectTrigger, type SelectTriggerProps, useForwardProps } from 'reka-ui';
import { computed, type HTMLAttributes } from 'vue';

const props = defineProps<SelectTriggerProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props;

  return delegated;
});

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <SelectTrigger
    v-bind="forwardedProps"
    :class="
      cn(
        'flex h-10 w-full items-center justify-between rounded-md border border-slate-200 bg-white px-3 py-2 text-start text-sm ring-offset-white focus:ring-2 focus:ring-slate-950 focus:ring-offset-2 focus:outline-hidden disabled:cursor-not-allowed disabled:opacity-50 data-placeholder:text-slate-500 [&>span]:truncate',
        props.class,
      )
    "
  >
    <slot />
    <SelectIcon asChild>
      <i class="fa-light fa-chevron-down h-4 w-4 shrink-0 scale-75 opacity-75"></i>
    </SelectIcon>
  </SelectTrigger>
</template>
